import BaseAPI from "./BaseAPI";
import ServiceApiUrlsStore from "../stores/ServiceApiUrlsStore";

class ContentAPIWrapper {
  constructor(api) {
    this.api = api;
  }

  get(organizationId) {
    return this.api
      .get(`/org/${organizationId}/content`)
      .then((data) => data.body);
  }

  getPage(organizationId, pageId) {
    return this.api
      .get(`/org/${organizationId}/pages/${pageId}`)
      .then((data) => data.body);
  }

  getProjects(organizationId) {
    return this.api
      .get(`/org/${organizationId}/projects`)
      .then((data) => data.body);
  }

  getProjectPages(organizationId, projectId) {
    return this.api
      .get(`/org/${organizationId}/projects/${projectId}/pages`)
      .then((data) => data.body);
  }

  getIndex(organizationId) {
    return this.api
      .get(`/org/${organizationId}/index`)
      .then((data) => data.body);
  }
}

class ContentAPI extends BaseAPI {
  constructor(token) {
    super(ServiceApiUrlsStore.getContentServiceUrl(), token);
    this.content = new ContentAPIWrapper(this);
  }
}

export default ContentAPI;
